import { useUserContext } from 'lib/context'
import { useEffect } from 'react'
import PubSub from 'pubsub-js'
import { MercureMessage } from 'lib/dto'
import { FC } from 'lib/component-utils'
import { match } from 'ts-pattern'

const Events: FC = () => {
  const { user, theme } = useUserContext()

  useEffect(() => {
    const isDev = process.env.NEXT_PUBLIC_MERCURE_TOPIC_PREFIX?.includes('dev')
    const topic = match(theme.hostType)
      .with('vtb', () =>
        isDev
          ? process.env.NEXT_PUBLIC_MERCURE_TOPIC_PREFIX
          : process.env.NEXT_PUBLIC_MERCURE_TOPIC_PREFIX?.replace('/', '/vtb-')
      )
      .with('psb', () =>
        isDev
          ? process.env.NEXT_PUBLIC_MERCURE_TOPIC_PREFIX
          : process.env.NEXT_PUBLIC_MERCURE_TOPIC_PREFIX?.replace('/', '/psb-')
      )
      .otherwise(() => process.env.NEXT_PUBLIC_MERCURE_TOPIC_PREFIX)

    const eventSource = new EventSource(
      encodeURI(
        `${process.env.NEXT_PUBLIC_MERCURE_USER_URL}?topic=${topic}/notifications/user/${user.id}`
      ),
      { withCredentials: true }
    )

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data) as MercureMessage
      PubSub.publish(data.event, data.data)
    }

    return () => eventSource.close()
  }, [user.id])
  return null
}

export default Events
